/* Rednas Kitchen: koppeling met de cookiebanner van Shopify.

   De conceptsite had een eigen banner. Die is hier weg: Shopify toont zijn
   eigen privacybanner (Instellingen, Klantprivacy) en die is als enige
   gekoppeld aan de toestemming waar de trackingpixels op wachten. Twee banners
   naast elkaar was niet alleen lelijk, de onze regelde ook niets.

   Wat hier overblijft: de knop op de pagina Cookie-instellingen opent het
   voorkeurenvenster van Shopify, en de statusregel laat zien wat er nu aan staat. */
(function () {
  function api() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function toonStatus() {
    var el = document.querySelector("[data-cookie-status]");
    if (!el) return;
    var p = api();
    if (!p || typeof p.currentVisitorConsent !== "function") {
      el.textContent = "Je cookievoorkeuren beheer je via de knop hieronder.";
      return;
    }
    var c = p.currentVisitorConsent();
    var aan = [];
    if (c.analytics === "yes") aan.push("analytische cookies");
    if (c.marketing === "yes") aan.push("marketingcookies");
    if (c.preferences === "yes") aan.push("voorkeurscookies");
    el.textContent = aan.length
      ? "Je huidige keuze: noodzakelijke cookies, " + aan.join(", ") + "."
      : "Je huidige keuze: alleen noodzakelijke cookies.";
  }

  function openVoorkeuren(e) {
    if (e) e.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
      window.privacyBanner.showPreferences();
    } else if (window.privacyBanner && typeof window.privacyBanner.showBanner === "function") {
      window.privacyBanner.showBanner();
    }
  }

  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-cookie-open], [data-cookie-instellingen]");
    if (t) openVoorkeuren(e);
  });

  document.addEventListener("visitorConsentCollected", toonStatus);
  if (document.readyState !== "loading") toonStatus();
  else document.addEventListener("DOMContentLoaded", toonStatus);
  setTimeout(toonStatus, 1200);   // Shopify's script laadt asynchroon
})();
